import React, {useContext, useEffect, useState, createContext} from 'react';

// add local storage

type ContextStates = 'noTokenSet' | 'tokenSet' | 'loading';
export interface OpenAiTokenContextState {
    apiKey: string;
    tokenState: ContextStates;
    saveApiKey: (newApiKey: string) => void;
}

const OpenAiTokenContext = createContext<OpenAiTokenContextState>({
    apiKey: '',
    saveApiKey: () => {},
    tokenState: 'noTokenSet',
});

export const OpenAiTokenContextProvider = ({children}) => {
    const [apiKey, setApiKey] = useState(localStorage.getItem('API_KEY') || '');
    const [tokenState, setTokenState] = useState<ContextStates>('loading');

    useEffect(() => {
        if (localStorage.getItem('API_KEY')) {
            setApiKey(localStorage.getItem('API_KEY') || '');
            setTokenState('tokenSet');
        }
    }, []);

    const saveApiKey = (newApiKey: string) => {
        setApiKey(newApiKey);
        localStorage.setItem('API_KEY', newApiKey);
        setTokenState('tokenSet');
    };

    return (
        <OpenAiTokenContext.Provider value={{apiKey, saveApiKey, tokenState}}>{children}</OpenAiTokenContext.Provider>
    );
};

export const useOpenAiTokenContext = () => {
    return useContext(OpenAiTokenContext);
};
